import { render, staticRenderFns } from "./supplierHome.vue?vue&type=template&id=75632bd6&"
import script from "./supplierHome.vue?vue&type=script&lang=js&"
export * from "./supplierHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports